export const HEAD_TABLE_PROPS = [
  {
    id: 'ID',
    label: 'ID',
    align: 'center',
  },
  {
    id: 'name',
    label: 'Tên cửa hàng',
    align: 'center',
  },
  {
    id: 'address',
    label: 'Địa chỉ',
    align: 'center',
  },
  {
    id: 'coordinates',
    label: 'Tọa độ ',
    align: 'center',
  },
  { label: '', align: 'center' },
];
